import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapLabelComponent = React.lazy(function () {
    return import('../../bootstrap-components/components/BTLabel');
});
var bootStrapLabelComponent = function (props) {
    return (React.createElement(BootStrapLabelComponent, __assign({}, props)));
};
var LabelComponent = function (props) {
    var componentToDisplay = bootStrapLabelComponent(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapLabelComponent(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
LabelComponent.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'light',
    labelColor: 'Black'
};
export default LabelComponent;
//# sourceMappingURL=LabelComponent.js.map